module.exports = __webpack_public_path__ + "media/images/photos/homepage-bg-a44a146ee75039531b921c836389964f.jpg";